import {
  selectBrand,
  selectFavoriteFilter,
  selectTag,
} from "@shared/actions/games";
import { SHOW_ALL } from "@shared/constants/game";
import { useGames } from "@shared/hooks/games";
import { useUser } from "@shared/hooks/user";
import { TAG_RECOMMENDED } from "@shared/modules/recommended-games";
import { SerializedGame } from "@shared/types";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { recommendationService } from "../recommendation-service";

const MAX_REC_GAMES_SECTION_LENGTH = 5;
export const useRecommendationGames = (): {
  recommendationGames: Array<SerializedGame>;
  handleRecommendationFilter: () => void;
} => {
  const dispatch = useDispatch();
  const games = useGames();
  const user = useUser();
  const [sortedGames, setSortedGames] = useState<Array<SerializedGame>>([]);

  const handleRecommendationFilter = useCallback(() => {
    dispatch(selectBrand(SHOW_ALL));
    dispatch(selectFavoriteFilter(false));
    dispatch(selectTag(TAG_RECOMMENDED));
  }, [dispatch]);

  const fetchRecommendedGames = useCallback(async () => {
    await recommendationService.fetchGames();
    const sorted = recommendationService.sortedAllGames(games);

    if (sorted.length > MAX_REC_GAMES_SECTION_LENGTH) {
      return setSortedGames(sorted.slice(0, 5));
    }

    setSortedGames(sorted);
  }, [games]);

  useEffect(() => {
    if (!user) {
      return;
    }

    fetchRecommendedGames();
  }, []);

  return {
    recommendationGames: sortedGames,
    handleRecommendationFilter,
  };
};
